import _ from 'lodash'
import React, { Component } from 'react';
import { Container, Header, Button, Icon, Divider, Form, Loader, Segment, Dimmer, FormField, FormSelect, Checkbox, Image, Grid, Popup } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import {YouTubeLinks} from './info/YouTubeLinks.js';

import {summaries} from './info/summaries.js';
import {categories} from './info/categories.js';
import { FeaturedVideos } from './Helpers.js';
// import RecordingStorageHook from './RecordingStorageHook.js';
import { API_URL, WEB_URL } from '../App.js';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import ReactGA from "react-ga4";
import { customFontFam3, customTitleFontFam3, customFirefoxTitleFontFam } from './constants/constants.js';
import { ReactMediaRecorder } from "react-media-recorder";
import axios from 'axios';
import ReCAPTCHA from "react-google-recaptcha";
import Mirt from 'react-mirt';
import 'react-mirt/dist/css/react-mirt.css';


ReactGA.initialize("G-JZB9CXH4GJ")
// const categories = _.times(6, (i) => (
//   <Grid.Column key={i}>
//   	<div>
// 	    <Image src='/images/categories1.jpg' />
// 	    <h3 className='yugtun'>Ellavut</h3>
// 	    Weather, Climate
// 	  </div>
//   </Grid.Column>
// ))

// const keywords = _.times(6, (i) => (
//   <Grid.Column key={i}>
//   	<Button basic color='blue' size='mini'>Yugtun<br /><em>inYup'ik</em></Button>
//   </Grid.Column>
// ))

let customFontFam = customFontFam3
let customTitleFontFam = customTitleFontFam3
let customFontFam2 = {fontFamily:customTitleFontFam3}
let letterbutton = {fontFamily:customFontFam3,paddingTop:'10px',paddingBottom:'10px',paddingRight:'14px',paddingLeft:'14px',fontSize:'16px'}
const isFirefox = typeof InstallTrigger !== 'undefined';

if (isFirefox) {
  customFontFam = customFirefoxTitleFontFam
  customTitleFontFam = customFirefoxTitleFontFam
  customFontFam2 = {fontFamily:customFirefoxTitleFontFam}
  letterbutton = {fontFamily:customFirefoxTitleFontFam,paddingTop:'10px',paddingBottom:'10px',paddingRight:'14px',paddingLeft:'14px',fontSize:'16px'}
}


class Validate extends Component {
	constructor(props) {
		super(props);
		this.state = {
			// show: false,
			// showAllElders: false,
			// categoriesDisplayed: ['1','2','3','4','5','6'],
			// featuredVideoIDs:['3TIkchKpXqY','F_bWrmqQB74',],
			// featuredVideoIDs2:['XcMTNy-xdF4','E6h9Cryzk3M',],
			// featuredZooms:['sS4vCvvOj8M','r78afbyVauw','kGCA7_Gc2ys','UbhmhRJClhg','NaYBwnGnA_0','tNLboGKVYhY'],
			// // eldersList: [],
			// showMoreVideos:false,
			// recordedBlob:[],
			// sending:false,
			// retrievingRecording:false,
			// // returnedTranscript:'',
			// returnedTranscript:"",
			// recaptchaAllowed:false,
			// currentAudioFileToSave:[],
			validationData:[]
		}
	}

	componentDidMount() {
      axios
        .get(API_URL + "sugtstunCrowdsourceValidation", {
          // onDownloadProgress: (progressEvent) => {
          //   this.setState({progressData1:Math.round( progressEvent.loaded )})
          // },
        }).then(response => {
        	console.log(response)
        	this.setState({validationData:response.data})
        })
	}


  repeatAudio(audio, event, data) {
  	// console.log(audio)
    if (!this.state.playingAudio) {

      let sound = new Audio(API_URL + "sugtstunCrowdsourceAudio/" + audio);
      this.setState({playingAudio: true});

      sound.play()

      sound.onended=()=>{
        this.setState({playingAudio: false});
      }
    }
  }


	render() {
		console.log(this.state)
		let showLargerTable = window.innerWidth >= 480
		return (
			<div className='home'>
				<div className='yugtatun'>Not Yet Validated</div>
				<Grid>
						<Grid.Row columns={5}>
							<Grid.Column>
								<div>{'name'}</div>
							</Grid.Column>
							<Grid.Column>
								<div>{'age'}</div>
							</Grid.Column>
							<Grid.Column>
								<div>{'sentence'}</div>
							</Grid.Column>
							<Grid.Column>
								<div>{'validated'}</div>
							</Grid.Column>
							<Grid.Column>
								<div>{'audio'}</div>
							</Grid.Column>
						</Grid.Row>
					{this.state.validationData.map((d)=>
						<Grid.Row columns={5}>
							<Grid.Column>
								<div>{d['name']}</div>
							</Grid.Column>
							<Grid.Column>
								<div>{d['age']}</div>
							</Grid.Column>
							<Grid.Column>
								<div>{d['sentence']}</div>
							</Grid.Column>
							<Grid.Column>
								{d['validated'] == 'no' ?
									<div>
										<Icon circular name='thumbs up outline' style={{cursor:'pointer'}} onClick={()=>{console.log('accept')}} />
										<Icon circular name='thumbs down outline' style={{cursor:'pointer'}} onClick={()=>{console.log('reject')}} />
									</div>
									:
									null
								}
							</Grid.Column>
							<Grid.Column>
								<Icon circular onClick={()=>this.repeatAudio(d['filename'])} style={{fontSize:'16px',color:'#8F8F8F',cursor:'pointer'}} name='volume up' />
							</Grid.Column>
						</Grid.Row>
					)}
				</Grid>
				<div className='yugtatun'>Accepted</div>
				<Grid>
						<Grid.Row columns={5}>
							<Grid.Column>
								<div>{'name'}</div>
							</Grid.Column>
							<Grid.Column>
								<div>{'age'}</div>
							</Grid.Column>
							<Grid.Column>
								<div>{'sentence'}</div>
							</Grid.Column>

							<Grid.Column>
								<div>{'audio'}</div>
							</Grid.Column>
						</Grid.Row>
					{this.state.validationData.map((d)=>
						<Grid.Row columns={5}>
							<Grid.Column>
								<div>{d['name']}</div>
							</Grid.Column>
							<Grid.Column>
								<div>{d['age']}</div>
							</Grid.Column>
							<Grid.Column>
								<div>{d['sentence']}</div>
							</Grid.Column>

							<Grid.Column>
								<Icon circular onClick={()=>this.repeatAudio(d['filename'])} style={{fontSize:'16px',color:'#8F8F8F',cursor:'pointer'}} name='volume up' />
							</Grid.Column>
						</Grid.Row>
					)}
				</Grid>
				<div className='yugtatun'>Rejected</div>
				<Grid>
						<Grid.Row columns={5}>
							<Grid.Column>
								<div>{'name'}</div>
							</Grid.Column>
							<Grid.Column>
								<div>{'age'}</div>
							</Grid.Column>
							<Grid.Column>
								<div>{'sentence'}</div>
							</Grid.Column>

						</Grid.Row>
					{this.state.validationData.map((d)=>
						<Grid.Row columns={5}>
							<Grid.Column>
								<div>{d['name']}</div>
							</Grid.Column>
							<Grid.Column>
								<div>{d['age']}</div>
							</Grid.Column>
							<Grid.Column>
								<div>{d['sentence']}</div>
							</Grid.Column>

						</Grid.Row>
					)}
				</Grid>
			</div>
		);
	}
}
export default Validate;